export default "__VITE_ASSET__CWqLPuII__"